import { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import { isValidInput } from "../../utils/validations";

interface RolesListTopbarProps {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  setDebouncedSearchTerm: (searchTerm: string) => void;
}

const RolesListTopbar = ({ searchTerm, setSearchTerm, setDebouncedSearchTerm }: RolesListTopbarProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subadmin/roles/add")}
          >
            <AddIcon /> Add Role
          </Button>
        </div>
      </div>
    </>
  );
};

export default RolesListTopbar;
